import { Flex, Text, Link } from '@chakra-ui/react';
import React from 'react';

import { isCustomerDashboard } from 'packages/common-frontend/utils';
import { LoginForm } from 'packages/logged-out/ui/LoginForm';

type LoggedOutContainerProps = {
  onSubmit?: () => void;
  logoImage: React.ReactElement;
};
export const LoggedOutContainer = ({
  onSubmit,
  logoImage,
}: LoggedOutContainerProps) => {
  return (
    <Flex
      width={['auto', '380px', '400px', '440px']}
      justify="center"
      height="100%"
      direction="column"
      align="center"
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
    >
      <Flex width="100%" marginBottom="20px" justifyContent="center">
        {logoImage}
      </Flex>
      <LoginForm onSubmit={onSubmit} />
      {isCustomerDashboard() && (
        <Text fontSize="xs">
          Don&apos;t have an account?{' '}
          <Link href="https://www.finleycms.com/contact" color="teal">
            Schedule a demo
          </Link>
        </Text>
      )}
    </Flex>
  );
};
